module.exports = __webpack_public_path__ + "img/pro-xtIcon2.281a4ec2.png";